import * as THREE from 'three';

const COLORS = {
  feedLight: 0xe6b542,
  feedDark: 0x906729,
  ring: 0x555555,
  bin: 0x878787,
  legs: 0x878787,
  lid: 0x878787,
};

export const getMaterials = (colors = {}) => {
  const clippingPlane = new THREE.Plane(new THREE.Vector3(-1, 0, 0 ), 0);
  const setClippingPlane = (material) => {
    material.clippingPlanes = [clippingPlane];
  };

  const adjustedColors = { ...COLORS, ...colors };

  const yellowMaterial = new THREE.MeshPhongMaterial({ color: adjustedColors.feedLight });
  yellowMaterial.side = THREE.FrontSide;
  setClippingPlane(yellowMaterial);

  const yellowDarkBacksideMaterial = new THREE.MeshBasicMaterial({ color: adjustedColors.feedDark });
  yellowDarkBacksideMaterial.side = THREE.BackSide;
  setClippingPlane(yellowDarkBacksideMaterial);

  const yellowDarkMaterial = new THREE.MeshBasicMaterial({ color: adjustedColors.feedDark });
  yellowDarkMaterial.side = THREE.DoubleSide;
  setClippingPlane(yellowDarkMaterial);

  const ringMaterial = new THREE.MeshBasicMaterial({ color: adjustedColors.ring });
  ringMaterial.side = THREE.FrontSide;

  const feedMaterial = new THREE.MeshNormalMaterial();
  feedMaterial.side = THREE.DoubleSide;
  setClippingPlane(feedMaterial);

  const binMaterial = new THREE.MeshBasicMaterial({ color: adjustedColors.bin });
  binMaterial.side = THREE.BackSide;
  binMaterial.shadowSide = THREE.DoubleSide;
  setClippingPlane(binMaterial);

  const legMaterial = new THREE.MeshPhongMaterial({ color: adjustedColors.legs });
  legMaterial.side = THREE.DoubleSide;
  legMaterial.clipShadows = true;
  setClippingPlane(legMaterial);

  const lidLipMaterial = new THREE.MeshBasicMaterial({ color: adjustedColors.lid });
  lidLipMaterial.side = binMaterial.side;
  lidLipMaterial.shadowSide = THREE.DoubleSide;
  setClippingPlane(lidLipMaterial);

  const lidLipDoubleMaterial = new THREE.MeshBasicMaterial({ color: adjustedColors.lid });
  lidLipDoubleMaterial.side = THREE.DoubleSide;
  lidLipDoubleMaterial.shadowSide = THREE.DoubleSide;
  setClippingPlane(lidLipDoubleMaterial);

  const groundMaterial = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    specular: 0xffffff,
  });
  groundMaterial.side = THREE.DoubleSide;

  return {
    clippingPlane,
    yellowMaterial,
    yellowDarkBacksideMaterial,
    yellowDarkMaterial,
    ringMaterial,
    feedMaterial,
    binMaterial,
    legMaterial,
    lidLipMaterial,
    lidLipDoubleMaterial,
    groundMaterial,
  };
};
